export default __webpack_public_path__ + "static/media/shape.8d4139e0.svg";